import { without } from 'lodash';
import { labeled, enumRequired } from '../../util/joi';
import { schema as objectiveTypeBaseReasonInterestOnly } from './ObjectiveTypeBaseReasonInterestOnly.schema';
import { ImportantOption, importantOptions } from '../global/ImportantOption.enum';
import {
  ObjectivePreferredDurationOption,
  objectivePreferredDurationOptions
} from './ObjectivePreferredDurationOption.enum';
import { PaymentFrequency, paymentFrequencies } from '../global/PaymentFrequency.enum';

export const schema = (Joi: any, label: string) => {
  const availableImportantOptions = without(
    importantOptions,
    ImportantOption.none.name,
    ImportantOption.most_important.name,
    ImportantOption.somewhat_important.name,
    ImportantOption.least_important.name
  );
  const availableObjectivePreferredDurationOptions = without(
    objectivePreferredDurationOptions,
    ObjectivePreferredDurationOption.none.name,
    ObjectivePreferredDurationOption.six_months.name,
    ObjectivePreferredDurationOption.twelve_months.name,
    ObjectivePreferredDurationOption.eighteen_months.name,
    ObjectivePreferredDurationOption.two_years.name,
    ObjectivePreferredDurationOption.two_years_plus.name
  );
  const availablePaymentFrequencies = without(
    paymentFrequencies,
    PaymentFrequency.none.name,
    PaymentFrequency.quarterly.name,
    PaymentFrequency.semiannual.name,
    PaymentFrequency.annually.name
  );
  return Joi.object()
    .keys({
      type: enumRequired(Joi, availableImportantOptions, labeled(label, 'Interest only'))
    })
    .when(
      Joi.object({
        type: Joi.object().keys({ name: Joi.string().valid(ImportantOption?.important?.name) })
      }),
      {
        then: Joi.object({
          preferredDuration: enumRequired(
            Joi,
            availableObjectivePreferredDurationOptions,
            labeled(label, 'Indicate the preferred duration of the interest only period')
          ),
          preferredPaymentFrequency: enumRequired(
            Joi,
            availablePaymentFrequencies,
            labeled(label, 'Indicate preferred repayment frequency')
          ),
          reason: objectiveTypeBaseReasonInterestOnly(
            Joi,
            labeled(label, 'Where interest only is important, why? - ')
          )
        })
      }
    );
};

export default {
  schema
};
